import React, { Component } from 'react'
import { categoriesService } from '../../_services/categories.service'
import { Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'
import unitTypes from '../../_constants/unitTypes'

class AsyncCategorySelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      defaultValue: this.props.defaultValue,
      categoryType: undefined,
      data: []
    }
  }

  componentDidMount() {
    this.getCategoryType()
  }

  getCategoryType = () => {
    // console.log(this.props.categoryType);

    if (this.props.categoryType !== undefined) {
      this.setState({ categoryType: this.props.categoryType }, () => {
        this.getData()
      })
    } else {
      const { user } = this.props
      let userType = parseInt(user.userType, 0)
      let categoryType = undefined

      if (user && [3, 6, 10].includes(userType)) {
        var unitType = unitTypes.filter(el => el.userType === userType)[0]

        if (unitType !== undefined) {
          categoryType = unitType.categoryType
        }

        if (categoryType !== undefined) {
          this.setState({ categoryType: categoryType }, () => {
            this.getData()
          })
        } else {
          this.getData()
        }
      } else {
        this.getData()
      }
    }
  }

  getData = () => {
    this.setState({ loading: true })
    categoriesService
      .getAll(this.state.categoryType)
      .then(res => {
        // console.log(res.data);

        let data = res.data

        if (this.state.onlyMainClass) {
          data = data.filter(el => el.categoryClass === 0)
        }

        if (this.state.onlySecondaryClass) {
          data = data.filter(el => el.categoryClass === 1)
        }

        if (this.state.onlyThirdaryClass) {
          data = data.filter(el => el.categoryClass === 2)
        }

        data = data.map(elm => ({
          text: elm.name,
          value: elm.id,
          categoryClass: elm.categoryClass
        }))
        // console.log(data, this.state.categoryType);

        this.setState({ data: data, loading: false, isSubmitting: false })
      })
      .catch(error => {
        this.setState({ loading: false })
        // console.log(error)
      })
  }

  async componentWillReceiveProps(nextProps) {
    // console.log(nextProps.categoryType);

    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue })
      // this.getData();
    }

    if (nextProps.categoryType !== this.state.categoryType) {
      this.setState({ categoryType: nextProps.categoryType }, () => {
        this.getData()
      })
    }

    if (nextProps.disabled !== this.state.disabled) {
      this.setState({ disabled: nextProps.disabled })
    }

    if (nextProps.onlyMainClass !== this.state.onlyMainClass) {
      this.setState({ onlyMainClass: nextProps.onlyMainClass }, () => {
        if (this.state.data) {
          let data = this.state.data.filter(el => el.categoryClass === 0)
          this.setState({ data: data })
        } else {
          this.getData()
        }
      })
    }

    if (nextProps.onlySecondaryClass !== this.state.onlySecondaryClass) {
      this.setState(
        { onlySecondaryClass: nextProps.onlySecondaryClass },
        () => {
          if (this.state.data) {
            let data = this.state.data.filter(el => el.categoryClass === 1)
            this.setState({ data: data })
          } else {
            this.getData()
          }
        }
      )
    }

    if (nextProps.onlyThirdaryClass !== this.state.onlyThirdaryClass) {
      this.setState({ onlyThirdaryClass: nextProps.onlyThirdaryClass }, () => {
        if (this.state.data) {
          let data = this.state.data.filter(el => el.categoryClass === 2)
          this.setState({ data: data })
        } else {
          this.getData()
        }
      })
    }
  }

  handleChange = e => {
    let selected = e
    this.setState({ selected: selected })
    this.props.onChange(selected)
  }

  render() {
    const { data, loading, defaultValue, disabled } = this.state
    const { clearable, className } = this.props

    return (
      <Dropdown
        placeholder=""
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        className={className}
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedAsyncCategorySelect = connect(mapStateToProps)(
  AsyncCategorySelect
)
export { connectedAsyncCategorySelect as AsyncCategorySelect }
